import PlayerAssetsModel from "./PlayerAssetsModel";

export default class PlayerShortModel {
    public id: string = "";
    public name: string = "";
    public position: string = "";
    public shirtNumber: number;
    public assets: PlayerAssetsModel = null;
    public type: string = "";
}